import account from '@app-builder/locales/ar/account.json';
import analytics from '@app-builder/locales/ar/analytics.json';
import api from '@app-builder/locales/ar/api.json';
import auth from '@app-builder/locales/ar/auth.json';
import cases from '@app-builder/locales/ar/cases.json';
import client360 from '@app-builder/locales/ar/client360.json';
import common from '@app-builder/locales/ar/common.json';
import continuousScreening from '@app-builder/locales/ar/continuous-screening.json';
import data from '@app-builder/locales/ar/data.json';
import decisions from '@app-builder/locales/ar/decisions.json';
import filters from '@app-builder/locales/ar/filters.json';
import graph from '@app-builder/locales/ar/graph.json';
import lists from '@app-builder/locales/ar/lists.json';
import navigation from '@app-builder/locales/ar/navigation.json';
import scenarios from '@app-builder/locales/ar/scenarios.json';
import screeningTopics from '@app-builder/locales/ar/screening-topics.json';
import screenings from '@app-builder/locales/ar/screenings.json';
import settings from '@app-builder/locales/ar/settings.json';
import upload from '@app-builder/locales/ar/upload.json';
import userScoring from '@app-builder/locales/ar/user-scoring.json';
import workflows from '@app-builder/locales/ar/workflows.json';

export const ar = {
  account,
  analytics,
  api,
  cases,
  client360,
  common,
  continuousScreening,
  data,
  decisions,
  filters,
  graph,
  navigation,
  lists,
  auth,
  screenings,
  scenarios,
  screeningTopics,
  settings,
  upload,
  'user-scoring': userScoring,
  workflows,
};
